var quiltInterval,
	quiltSection = document.querySelector('section.quilt'),
	quiltContainer = document.querySelector('.quilt-container');

if(quiltContainer) {
	var images = quiltContainer.querySelectorAll('.bg-wrapper'),
		json = JSON.parse(quiltContainer.dataset.json),
		limit = quiltContainer.dataset.limit;

	// Insert a second img element for switching
	[].slice.call(images).forEach(function(figure) {
		figure.querySelector('img').insertAdjacentHTML('afterend', '<img alt="" class="bg-container not-lazy" height="176" src="" width="176">');
	});

	// Split current images and unused images
	var currentImages = {};

	for(var i=1; i<=limit; i++) {
		currentImages[i] = json[i];
		delete json[i];
	}

	// Start Quilt
	var quiltWaypoint = new Waypoint({
		element: quiltSection,
		handler: function(direction) {
			quiltInterval = setInterval(animateQuilt, 3000);

			this.destroy();
		},
		offset: '100%'
	});

	// Stop animation on hover
	quiltContainer.addEventListener('mouseover', function() {
		clearInterval(quiltInterval);
	});

	// Start animation on hover out
	quiltContainer.addEventListener('mouseout', function() {
		quiltInterval = setInterval(animateQuilt, 3000);
	});
}

function animateQuilt() {
	var baseKey,
		baseIndex = Math.floor(Math.random() * limit),
		baseFigure = images[baseIndex],
		baseLink = baseFigure.querySelector('a'),
		img1 = baseFigure.querySelector('img:nth-of-type(1)'),
		img2 = baseFigure.querySelector('img:nth-of-type(2)'),
		baseImg = window.getComputedStyle(img1).display == 'block' ? img1 : img2,
		replacementImg = baseImg == img1 ? img2 : img1,
		jsonKeys = Object.keys(json),
		replacementKey = jsonKeys[jsonKeys.length * Math.random() << 0],
		replacement = json[replacementKey],
		replacementLink = replacement ? replacement.link : '';

	// Get key of current image
	for(var key in currentImages) {
		if(currentImages[key].src == baseImg.src) {
			baseKey = key;
			break;
		}
	}

	// Replace the img src
	replacementImg.src = replacement.src;

	// Animate the img
	Velocity(baseImg, 'fadeOut', {duration: 500, display: 'none'});
	Velocity(replacementImg, 'fadeIn', {duration: 500, display: 'block'});

	// Replace the caption
	baseFigure.querySelector('figcaption').innerHTML = replacement.caption.value;

	// Replace the link
	if(replacementLink) {
		if(baseLink)
			baseLink.href = replacementLink;
		else
			baseFigure.innerHTML = '<a href="'+replacementLink+'">'+baseFigure.innerHTML+'</a>';
	} else if(!replacementLink && baseFigure.querySelector('a')) {
		baseFigure.innerHTML = baseFigure.querySelector('a').innerHTML;
	}

	// Reset the objects
	currentImages[replacementKey] = json[replacementKey];
	delete json[replacementKey];

	json[baseKey] = currentImages[baseKey];
	delete currentImages[baseKey];
}